<div class="topic">
  <div class="links-row">
    <a [href]="rmn.appLink" target="_blank">
      {{ rmn.name }}
    </a>
    <q9-link-button
      *ngIf="hasSfSetupPageLink()"
      [matTooltip]="'CORE.ATTACHMENTS.GO_TO_SETUP_PAGE' | translate"
      [matTooltipPosition]="'below'"
      (click)="openSFSetupPage()">
      <mat-icon svgIcon="sf_orgs"></mat-icon>
    </q9-link-button>
  </div>

  <div class="summary-block" *ngIf="rmn.summary">
    <div class="block-label">
      {{ 'CORE.ATTACHMENTS.SF_NODE_SUMMARY' | translate }}
    </div>
    <div class="block-text">
      {{ rmn.summary }}
    </div>
  </div>

  <div class="sf-description-block" *ngIf="rmn.description">
    <div class="block-label">
      {{ 'CORE.ATTACHMENTS.SF_NODE_DESCRIPTION' | translate }}
    </div>
    <div class="block-text">
      {{ rmn.description }}
    </div>
  </div>
</div>
